module.exports = __webpack_public_path__ + "static/media/personsbg.ff5c713a.svg";